import React, { memo } from 'react';
import { useRecordContext } from 'react-admin';
import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography
} from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

import { S3FileField, JSONField } from '../fields';

export const SectionLabel = ({ children, icon: Icon }) => (
  <Box width="100%" mt={3} mb={1.5}>
    <Box display="flex" alignItems="center" gap={1} mb={0.5}>
      {Icon && <Icon sx={{ color: 'text.secondary', fontSize: 20 }} />}
      <Typography variant="subtitle1" fontWeight={600} color="text.secondary" textTransform="uppercase" letterSpacing={0.5} fontSize={13}>
        {children}
      </Typography>
    </Box>
    <Divider />
  </Box>
);

export const ShowField = ({ label, children }) => (
  <Box mb={2}>
    <Typography variant="caption" color="text.secondary" display="block" mb={0.25}>{label}</Typography>
    <Typography variant="body1" component="div">{children}</Typography>
  </Box>
);

export const LazyTabPanel = memo(({ children, active, visited }) => {
  if (!visited) return null;
  return (
    <Box role="tabpanel" sx={{ display: active ? 'block' : 'none', p: 3 }}>
      {children}
    </Box>
  );
});

export const EditTabPanel = ({ children, active }) => (
  <Box role="tabpanel" sx={{ display: active ? 'block' : 'none', p: 3 }}>
    {children}
  </Box>
);

export const DirectoryShowContent = memo(({ dirField, fileField, s3Field, configField }) => {
  const record = useRecordContext();
  if (!record) return null;
  const templateFile = record[fileField];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Card variant="outlined">
          <CardContent>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              <FolderIcon sx={{ fontSize: 16, mr: 0.5, verticalAlign: 'text-bottom' }} />
              Directory & Files
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <ShowField label="Editor Directory">{record[dirField] || '—'}</ShowField>
            <ShowField label="Template File">{templateFile?.name || '—'}</ShowField>
            <ShowField label="Direct File">
              <S3FileField source={s3Field} />
            </ShowField>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Card variant="outlined">
          <CardContent>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              <InsertDriveFileIcon sx={{ fontSize: 16, mr: 0.5, verticalAlign: 'text-bottom' }} />
              Config JSON
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Box sx={{ maxHeight: 500, overflow: 'auto', borderRadius: 1 }}>
              <JSONField source={configField} />
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
});
